import React from "react";
import Icon from "components/AppIcon";

const SummaryCards = ({ metrics }) => {
  const cards = [
    {
      label: "Total Portfolio Value",
      value: `$${metrics?.totalValue?.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      change: metrics?.dailyChange,
      changePct: metrics?.dailyChangePct,
      icon: "Wallet",
      color: "var(--color-primary)",
    },
    {
      label: "Overall Return",
      value: `${metrics?.overallReturn >= 0 ? "+" : ""}${metrics?.overallReturn?.toFixed(2)}%`,
      sub: `$${Math.abs(metrics?.overallReturnAbs)?.toLocaleString("en-US", { minimumFractionDigits: 2 })} ${metrics?.overallReturn >= 0 ? "gain" : "loss"}`,
      icon: "TrendingUp",
      color: metrics?.overallReturn >= 0 ? "var(--color-success)" : "var(--color-error)",
      positive: metrics?.overallReturn >= 0,
    },
    {
      label: "Realized P&L",
      value: `${metrics?.realizedPnl >= 0 ? "+" : ""}$${Math.abs(metrics?.realizedPnl)?.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      sub: "This month",
      icon: "DollarSign",
      color: metrics?.realizedPnl >= 0 ? "var(--color-success)" : "var(--color-error)",
      positive: metrics?.realizedPnl >= 0,
    },
    {
      label: "Margin Utilization",
      value: `${metrics?.marginUtilization?.toFixed(1)}%`,
      sub: `$${metrics?.marginUsed?.toLocaleString()} / $${metrics?.marginLimit?.toLocaleString()}`,
      icon: "Layers",
      color: metrics?.marginUtilization > 75 ? "var(--color-error)" : metrics?.marginUtilization > 50 ? "var(--color-warning)" : "var(--color-accent)",
      progress: metrics?.marginUtilization,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards?.map((card, i) => (
        <div
          key={i}
          className="rounded-xl border border-border p-4 md:p-5 flex flex-col gap-3"
          style={{ background: "var(--color-card)" }}
        >
          <div className="flex items-center justify-between">
            <span className="font-caption text-xs text-muted-foreground uppercase tracking-widest">{card?.label}</span>
            <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{ background: `${card?.color}18` }}>
              <Icon name={card?.icon} size={16} color={card?.color} />
            </div>
          </div>
          <div>
            <div className="font-heading text-xl md:text-2xl font-bold" style={{ color: card?.color }}>
              {card?.value}
            </div>
            {card?.change !== undefined && (
              <div className={`flex items-center gap-1 mt-1 text-xs font-caption ${card?.change >= 0 ? "text-green-400" : "text-red-400"}`}>
                <Icon name={card?.change >= 0 ? "ArrowUpRight" : "ArrowDownRight"} size={12} color={card?.change >= 0 ? "var(--color-success)" : "var(--color-error)"} />
                {card?.change >= 0 ? "+" : ""}${Math.abs(card?.change)?.toLocaleString("en-US", { minimumFractionDigits: 2 })} ({card?.changePct >= 0 ? "+" : ""}{card?.changePct?.toFixed(2)}%) today
              </div>
            )}
            {card?.sub && <div className="text-xs text-muted-foreground mt-1 font-caption">{card?.sub}</div>}
          </div>
          {card?.progress !== undefined && (
            <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${Math.min(card?.progress, 100)}%`, background: card?.color }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;